import { Box, ColorOptions, ModBox, Spacer, TextNew } from '@jfs/ui-new'
import { FC } from 'react'
import { useWindowDimensions } from '../../../util/util'
import { styles } from './styles'

const BeneficiaryData: FC<any> = ({ data, isEditMode, onAddAddressPress }: any) => {
  const viewPortWidth = useWindowDimensions()

  const themes = styles(viewPortWidth)

  return (
    <ModBox show={!isEditMode} {...themes.detailsContainer}>
      <TextNew type="titleBold16">{data?.name}</TextNew>
      <Spacer size={16} />
      <Box {...themes.detailsMainContainer}>
        <Box {...themes.detailsBeneContent}>
          <Box {...themes.detailsBeneSubContainer}>
            <TextNew fontSize={12} fontFamily="jiotype-medium" color={'BLACK_75'}>
              {'Email ID'}
            </TextNew>
            <Spacer size={4} direction="vertical" />
            <TextNew fontSize={12} fontFamily="jiotype-medium" color={'BLACK_75'}>
              {'Phone number'}
            </TextNew>
            <Spacer size={4} direction="vertical" />
            <TextNew fontSize={12} fontFamily="jiotype-medium" color={'BLACK_75'}>
              {'Beneficiary ID'}
            </TextNew>
            <Spacer size={4} direction="vertical" />
            <TextNew fontSize={12} fontFamily="jiotype-medium" color={'BLACK_75'}>
              {'Address'}
            </TextNew>
            <Spacer size={4} direction="vertical" />
          </Box>
          <Box {...themes.detailsBeneSubContainer} flex={0.7} alignItems={'flex-start'}>
            <TextNew fontSize={12} fontFamily="jiotype-medium" color="BLACK_21">
              {data?.email}
            </TextNew>
            <Spacer size={4} direction="vertical" />
            <TextNew fontSize={12} fontFamily="jiotype-medium" color="BLACK_21">
              {data?.phone}
            </TextNew>
            <Spacer size={4} direction="vertical" />
            <TextNew fontSize={12} fontFamily="jiotype-medium" color="BLACK_21">
              {data?.id}
            </TextNew>
            <Spacer size={4} direction="vertical" />
            <ModBox onPress={onAddAddressPress} testID="addAddressPress" underlayColor={'GRAY_BORDER'}>
              <TextNew fontSize={12} fontFamily="jiotype-medium" color={'#225BD0' as ColorOptions} selectable={false}>
                {'+ Add Beneficiary Address'}
              </TextNew>
            </ModBox>
          </Box>
        </Box>
        <Box {...themes.divider} />
      </Box>
    </ModBox>
  )
}

export default BeneficiaryData
